// ⚠️ TEMPORAL — solo para revisar el diseño de la tabla en local. NO commitear.
import React from 'react';
import TalleresTable from './TalleresAdminTable';

const hoy = new Date();
const d = n => new Date(hoy.getTime() + n * 86400000).toISOString();

const horario = (sku, cupos, ocupados, reservados = 0) => ({
  _id: Math.random().toString(36).slice(2),
  dia: 'lunes', horaInicio: '10:00', horaFin: '11:00',
  cupos, cuposOcupados: ocupados, cuposReservados: reservados, sku,
});

const mock = [
  {
    _id: '1', nombre: 'Academia Preferente Lu-Mi-Vi',
    descripcion: 'Taller exclusivo para inscripciones preferentes por concepto de "excepcional", diseñado para personas que no cumplen con los requisitos del taller, en edad u origen.',
    recinto: { nombre: 'Academias Deportivas' },
    enCicloActivo: true, cicloActual: 7,
    inscripcionInicio: d(-2), inscripcionFin: null,
    actividadesInicio: d(17), actividadesFin: d(46),
    estado: 'activo', inscripcionesEstado: 'abiertas',
    horarios: [horario('77220021086318', 14, 0)],
  },
  {
    _id: '2', nombre: 'Academia Preferente Ma-Ju',
    descripcion: 'Taller exclusivo para inscripciones preferentes por concepto de "excepcional", diseñado para personas que no cumplen con los requisitos del taller, en edad u origen.',
    recinto: { nombre: 'Academias Deportivas' },
    enCicloActivo: true, cicloActual: 6,
    inscripcionInicio: d(-2), inscripcionFin: null,
    actividadesInicio: d(17), actividadesFin: d(46),
    estado: 'activo', inscripcionesEstado: 'abiertas',
    horarios: [horario(null, 14, 0)],
  },
  {
    _id: '3', nombre: 'Acondicionamiento Físico Lu-Mi-Vi 10:00 h.',
    descripcion: 'El acondicionamiento físico es una actividad integral que busca mejorar la condición física general de una persona, abarcando la fuerza, la resistencia, la flexibilidad, la agilidad y la coordinación. Su objetivo es optimizar la salud y el rendimiento para las actividades diarias y deportivas.',
    recinto: { nombre: 'Club Ñuñoa' },
    enCicloActivo: true, cicloActual: 10,
    inscripcionInicio: d(-5), inscripcionFin: d(10),
    actividadesInicio: d(17), actividadesFin: d(46),
    estado: 'activo', inscripcionesEstado: 'abiertas',
    horarios: [horario('1629747458675', 19, 3, 1)],
  },
  {
    // Caso a detectar: taller activo con las fechas del ciclo pasado.
    _id: '4', nombre: 'Aerobike Lu-Mi-Vi 08:00 h.',
    descripcion: 'Aerobike es un ejercicio aeróbico de intensidad moderada a alta realizado en una bicicleta estática, combinando resistencia y música para mejorar la capacidad cardiovascular, quemar calorías y tonificar músculos.',
    recinto: { nombre: 'Polideportivo de Ñuñoa' },
    enCicloActivo: true, cicloActual: 13,
    inscripcionInicio: d(-60), inscripcionFin: d(-40),
    actividadesInicio: d(-35), actividadesFin: d(-5),
    estado: 'activo', inscripcionesEstado: 'abiertas',
    horarios: [horario('70067373419531', 17, 17)],
  },
  {
    // Caso a detectar: sin fechas de actividades.
    _id: '5', nombre: 'Yoga Ma-Ju 19:00 h.',
    descripcion: 'Clase de yoga para todos los niveles.',
    recinto: { nombre: 'Club Ñuñoa' },
    enCicloActivo: false, cicloActual: 0,
    inscripcionInicio: null, inscripcionFin: null,
    actividadesInicio: null, actividadesFin: null,
    estado: 'pausado', inscripcionesEstado: 'pausadas',
    horarios: [horario('70067373419999', 20, 0)],
  },
  {
    // Caso a detectar: la inscripción cierra después de partir las actividades.
    _id: '6', nombre: 'Natación Infantil Sáb 10:00 h.',
    descripcion: 'Natación para niños de 6 a 12 años.',
    recinto: { nombre: 'Polideportivo de Ñuñoa' },
    enCicloActivo: true, cicloActual: 4,
    inscripcionInicio: d(-3), inscripcionFin: d(25),
    actividadesInicio: d(17), actividadesFin: d(60),
    estado: 'activo', inscripcionesEstado: 'abiertas',
    horarios: [horario('70067373411111', 48, 52)],
  },
];

const PreviewTable = () => (
  <div style={{ padding: 12, background: '#f1f5f9', minHeight: '100vh' }}>
    <TalleresTable talleres={mock} onRefresh={() => {}} />
  </div>
);

export default PreviewTable;
